import {
  MODAL_DISPLAY_TEXT_FOR_DELETING_ASSET,
  MODAL_DISPLAY_TEXT_FOR_DELETING_FOLDER,
} from '../constants';

export const getDeleteModalText = (foldersCount: number, contentsCount: number) => {
  if (contentsCount && !foldersCount) {
    return MODAL_DISPLAY_TEXT_FOR_DELETING_ASSET;
  }
  return MODAL_DISPLAY_TEXT_FOR_DELETING_FOLDER;
};
